import { Fragment, useEffect, useState } from "react";

import { parseUrlParams } from "./util.js";
import { apiLoginCompany } from "../utils/API/TrxNowAPI.js";

import TrxNowGoogleMap from "webapp/components/TrxNowMap/TrxNowGoogleMap.jsx";
import ListItems from "./ListItems";
import TrxNowLogo from "../assets/TopNav_Logo.png";

import { apiGetCallsReport } from "../utils/API/TrxNowAPI";

import DestMapMarker from "../assets/ui-img/map-markers/markerServiceLocation.png";
import TowMapMarker from "../assets/ui-img/map-markers/markerTow.png";
import stdMapMarker from "../assets/ui-img/map-markers/defaultMarker.svg";
import { devLog } from "utils/devLog";

const filters1 = [
  { name: "Customer Not Located", href: "#", bgColorClass: "bg-red-500" },
  { name: "In Progress", href: "#", bgColorClass: "bg-green-300" },
  { name: "Provider Cancelled", href: "#", bgColorClass: "bg-purple-500" },
  { name: "Approval Required", href: "#", bgColorClass: "bg-purple-300" },
];

const filters2 = [
  { name: "No Eligible Providers Identified", href: "#", bgColorClass: "bg-orange-500" },
  { name: "Operator Running 20% Late", href: "#", bgColorClass: "bg-yellow-500" },
  { name: "Payment Required", href: "#", bgColorClass: "bg-green-500" },
  { name: "Show Digital Service Calls Only", href: "#", bgColorClass: "bg-green-900" },
];

const filters3 = [
  { name: "No Provider Accepted, No Driver after 5 Min", href: "#", bgColorClass: "bg-blue-300" },
  { name: "Enroute to Destination Over 30 mins", href: "#", bgColorClass: "bg-blue-900" },
  { name: "Has GPS GPS Tracking", href: "#", bgColorClass: "bg-green-900" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [tokenId, setTokenId] = useState();
  const [companyParams, setCompanyParams] = useState();

  const getAndSaveQueryParams = () => {
    const urlParams = parseUrlParams();
    devLog(urlParams);
    setTokenId(urlParams["tokenid"] || "");

    return urlParams["tokenid"];
  };

  // on first load, run loginCompany API call and save data
  useEffect(() => {
    let urlToken = getAndSaveQueryParams();
    devLog("TokenId is:", urlToken);
    apiLoginCompany(urlToken, (currentCompanyParams) => {
      devLog("Company Params:", currentCompanyParams);
      setCompanyParams(currentCompanyParams);
    });
  }, []);

  return (
    <>
      <div className="min-h-full">
        {/* Static sidebar for desktop */}
        <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-portal lg:flex-col lg:border-r lg:border-gray-200 lg:bg-gray-100 lg:pt-5 lg:pb-4">
          <div className="flex flex-shrink-0 items-center px-6">
            <img className="h-12 w-auto" src={TrxNowLogo} alt="TrxNow" />
          </div>
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="mt-2 flex h-0 flex-1 flex-col overflow-y-auto pt-1">
            {/* Navigation */}
            <nav className="px-3 m-0">
              <div className="mt-4">
                <h1 className="font-bold text-xl">Active Cases:</h1>
                <ListItems />
              </div>
            </nav>
          </div>
        </div>

        {/* Main column */}
        <div className="flex flex-col lg:pl-portal h-full overflow-hidden overflow-y-clip">
          {/* Page title & actions */}
          <div className="border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
            <div>
              <h3 className="px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
                Filters
              </h3>

              <div className="mt-1 space-y-1 flex justify-evenly" role="group" aria-labelledby="desktop-teams-headline">
                <div>
                  {filters1.map((team) => (
                    <a
                      key={team.name}
                      href={team.href}
                      className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                    >
                      <span
                        className={classNames(team.bgColorClass, "w-2.5 h-2.5 mr-4 rounded-full")}
                        aria-hidden="true"
                      />
                      <span className="truncate">{team.name}</span>
                    </a>
                  ))}
                </div>

                <div className="ml-8">
                  {filters2.map((team) => (
                    <a
                      key={team.name}
                      href={team.href}
                      className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                    >
                      <span
                        className={classNames(team.bgColorClass, "w-2.5 h-2.5 mr-4 rounded-full")}
                        aria-hidden="true"
                      />
                      <span className="truncate">{team.name}</span>
                    </a>
                  ))}
                </div>

                <div className="ml-8">
                  {filters3.map((team) => (
                    <a
                      key={team.name}
                      href={team.href}
                      className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                    >
                      <span
                        className={classNames(team.bgColorClass, "w-2.5 h-2.5 mr-4 rounded-full")}
                        aria-hidden="true"
                      />
                      <span className="truncate">{team.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <main>
            {/* <button className="bg-blue-100 p-8" onClick={()=>{
							apiGetCallsReport(companyParams, (result)=>{
								devLog("getCallsReport return:", result);
							})
						}}>Testing Button</button> */}

            <TrxNowGoogleMap
              disablementCoords={{ lat: 36.317126, lng: -82.351134 }}
              destinationCoords={null}
              zoom={14}
              width={"100%"}
              height={window.innerHeight - 225}
              markers={[
                { position: { lat: 36.317126, lng: -82.351134 }, icon: stdMapMarker },
                { position: { lat: 36.329926, lng: -82.351934 }, icon: TowMapMarker },
              ]}
            />
          </main>
        </div>
      </div>
    </>
  );
}
